<div class="modal-header" style="padding: 0px">
  <h4 class="modal-title">{{'NOTATIONS_TITLE' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" matDialogClose>
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>
<div class="modal-body formModal" *ngIf="!showSpinner">


  <div id="content">

    <div id="dateCont">
      {{dateString}}
    </div>

    <div id="datePickerCont" style="display: flex; align-items: center">

      <div>{{ 'DATE_START' | translate }}</div>

      <input id="datePickerInput" matInput [matDatepicker]="picker" placeholder="Choose a date" [(ngModel)]="datePicker"
             [disabled]="disabled" (dateChange)="updateDate($event)">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>

      <ngb-timepicker [(ngModel)]="timePicker" [seconds]="true" [disabled]="disabled"></ngb-timepicker>

    </div>

    <div style="margin: 20px 0">
      <textarea *ngIf="disabled" disabled [(ngModel)]="justification" cols="90" rows="4">
        </textarea>
      <textarea *ngIf="!disabled" [(ngModel)]="justification" cols="90" rows="4"></textarea>

    </div>


    <div *ngIf="locations">
      <table class="table-striped" style="width: 100%">
        <tr class="header">
          <td>Location</td>
          <td>Sensor ID</td>
          <td *ngIf="notation.aboMath">Notations auto</td>
          <td>Manual notation</td>
          <td style="background-color: #0e84a2; color: white">Result</td>
        </tr>
        <tr *ngFor="let location of locations; let i = index" class="even"
            [ngClass]="[(i+1) % 2 === 0 ? 'even' : 'odd', location.parent ? '' : 'parent']">
          <td>{{location.name}}</td>
          <td>{{location.id}}</td>
          <td *ngIf="notation.aboMath">{{this.showSpinner ? '' : (location.automaticNote || '-')}}</td>
          <td>
            <mat-select [(value)]="this.showSpinner ? '' : location.note" [disabled]="disabled">
              <mat-option value="ignore">Ignore</mat-option>
              <mat-option *ngIf="location.automaticNote" value="auto">Auto</mat-option>
              <mat-option *ngFor="let note of noteArray" [value]="note">{{note}}
              </mat-option>
            </mat-select>
          </td>
          <td>{{this.showSpinner ? '' : getNoteResults(location)}}</td>
        </tr>
      </table>
    </div>
    <div class="infoNote" style="margin-top: 25px">
      {{'NOTATIONS_AUTO_WARNING' | translate}}
    </div>

    <div class="bootstrapStyle">
      <button (click)="submit()" class="btn btn-primary" *ngIf="!disabled">{{ 'NOTATIONS_FORM_ADD' |
        translate }}
      </button>
      <button  matDialogClose class="btn btn-neutral">{{ 'CANCEL' | translate }}</button>
    </div>

  </div>

</div>
